import { ManagementSecMainHeader, Table } from "components"
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { encodeToBase64 } from 'utils/encodeAndDecode.js'
import { AFFINITY_SCORE } from "../../../common/routes.js"
import { getAllAffinityActions } from 'apis/affinityScore/index.js'



function Index() {

    const navigate = useNavigate()
    const [affinityActions, setAffinityActions] = useState()
    const [pageNation, setPageNation] = useState({
        currentPage: 1,
        nextPage: null,
        prevPage: null,
    })

    const columns = [
        {
            Header: 'No',
            accessor: (row, rowIndex) => rowIndex + 1,
            id: 'no'
        },
        { Header: 'Action Name', accessor: 'action_name' },
        { Header: 'Score', accessor: 'score' },
        { Header: 'Type', accessor: 'type' },

        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ row }) => (
                <>
                    {row?.original?.status ?
                        <span className='p-2 text-green-500 bg-green-100 cursor-pointer rounded-3xl'>
                            Active
                        </span>
                        :
                        <span className='p-2 text-red-500 bg-red-100 cursor-pointer rounded-3xl'>
                            Inactive
                        </span>

                    }
                </>

            )
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <div>
                    <button onClick={() => handleEdit(row)} className='p-2 px-3 mr-1 text-white bg-green-500 rounded-xl'>Edit</button>
                </div>
            )
        }
    ];

    const handleBtn = async () => {
        navigate(AFFINITY_SCORE.CREATE_AFFINITY_SCORE)
    }

    const fetchAffinityActions = async (page) => {
        const res = await getAllAffinityActions(page)
        setAffinityActions(res?.data)
        const pagination = res?.pagination
        setPageNation({ currentPage: pagination?.current_page, nextPage: pagination?.next_page, prevPage: pagination?.previous_page })
    }



    const handleEdit = (row) => {
        const id = encodeToBase64(row.original.id);
        const url = `${AFFINITY_SCORE.CREATE_AFFINITY_SCORE}/${id}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };


    useEffect(() => {
        fetchAffinityActions(1)
    }, [])



    return (
        <div className='flex flex-col h-screen'>

            {/* Main Content Section */}
            <div className="bg-[#f8f8f8] h-screen w-full">
                {/* Header */}
                <div className="w-[96%] mx-auto my-10">
                    <ManagementSecMainHeader
                        mainHeading={"Offer"}
                        subHeading={"Manage your events effectively"}
                        btnText={"Add Affinity Score"}
                        handleBtn={handleBtn} />
                </div>
                {/* Table */}

                <div className="p-8">
                    {affinityActions &&
                        <Table columns={columns} data={affinityActions} pageNation={pageNation} handlePageNation={(value) => fetchAffinityActions(value)} />
                    }
                </div>
            </div>
        </div>
    )
}

export default Index